module.exports = __webpack_public_path__ + "media/images/wedding/11-1bf91f63bc75e2eafe18b8128101c489.jpg";